// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".title-tips[data-v-f1b499ee]{padding-bottom:10px;color:#333}.title-tips span[data-v-f1b499ee]{margin-right:14px;color:#999}", ""]);
// Exports
module.exports = exports;
